import React from 'react'


const ContactPage = (project_name, project_date, project_description) => {
  return (
    <div>
      
    </div>
  )
}

export default ContactPage